import actions from './multiple-session.actions'
import getters from './multiple-session.getters'
import state from './multiple-session.state'
import mutations from './multiple-session.mutations'

export default {
  namespaced: true,
  actions,
  getters,
  state,
  mutations,
}
